import { AxiosResponse } from 'axios'
import { TaggersDailyProgressReportResponse } from '../shared/models'
import { post } from './base/base-http-service'

export const listTaggersDailyProgressReportService = async (
  payload
): Promise<AxiosResponse<TaggersDailyProgressReportResponse>> => {
  return post(`taggers-daily-progress-report`, payload)
}
